import { useEffect } from 'react'
import { Heap } from '@helpers'

const createCapturer = () => {
  const start = performance.now()
  return () => performance.now() - start
}

const track = (value) =>
  Heap.trigger('Recording - Time Spent on page', {
    value
  })

export const useTracking = () => {
  useEffect(() => {
    const capture = createCapturer()
    const onBeforeUnload = () => {
      track(capture())
    }
    window.addEventListener('beforeunload', onBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload)
      track(capture())
    }
  }, [])
}
